import { Component, OnInit } from '@angular/core';
import { ISetOrResetPasswordRequest } from '@modeso/aumico-lib-users-fe';
import { UntilDestroy } from '@ngneat/until-destroy';

import { PasswordsBasePage } from '../passwords-base.page';
@UntilDestroy()
@Component({
    selector: 'aumico-set-password',
    templateUrl: './set-password.page.html',
    styleUrls: ['./set-password.page.scss'],
})
export class SetPasswordPage extends PasswordsBasePage implements OnInit {
    onPasswordSet(setPasswordData: ISetOrResetPasswordRequest): void {
        this.authProvider.dispatchSetPassword(setPasswordData);
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }
}
